define('score_bootstrap/Events/SearchResponseEvent',[
    "jquery",
    "score_ccf/extensions",
    "../Models/Search/IndexableItemBase"
], function ($, extensions, IndexableItemBase) {
    "use strict";

    function intOrNull(value) {
        value = parseInt(value, 10);
        return isNaN(value) ? null : value;
    }

    function SearchResponseEvent(query, items, page, perPage, totalItems, totalPages, facets) {
        if (items && (!Array.isArray(items) || !extensions.allOfType(items, IndexableItemBase))) {
            throw new TypeError("items should be array of IndexableItemBase");
        }

        if (facets && typeof facets !== "object") {
            throw new TypeError("facets should be object");
        }

        Object.defineProperties(this, {
            query:      {enumerable: true, value: query},
            items:      { enumerable: true, value: items || []           },
            facets:     { enumerable: true, value: facets || {}          },
            page:       { enumerable: true, value: intOrNull(page)       },
            perPage:    { enumerable: true, value: intOrNull(perPage)    },
            totalItems: { enumerable: true, value: intOrNull(totalItems) },
            totalPages: { enumerable: true, value: intOrNull(totalPages) }
        });
    }

    SearchResponseEvent.eventName = "SearchResponseEvent";
    SearchResponseEvent.serverError = SearchResponseEvent.eventName + ":serverError";

    return SearchResponseEvent;
});
